export default "./images/survio-3x7QW-assets-star_rating.png";